<script>
import convertToHtml from '@rei/rich-text-renderer';
import { useDynamicContent } from '@rei/cs-preview-fetch';
import LongformComponent from '@rei/landing-longform-component';

import analytics from '../../common/mixins/analytics';

export default {
  name: 'Longform',
  components: {
    LongformComponent,
  },
  mixins: [analytics],
  props: {
    additionalData: { type: Object, required: true, default: () => {} },
    componentModels: { type: Object, required: true, default: () => {} },
  },
  setup(props) {
    const getPreviewUrl = () => `/home/rs/long-form/live-preview?entryId=${props.componentModels?.uid}`;
    const { content: reactiveComponentModels } = useDynamicContent(props, getPreviewUrl);
    if (reactiveComponentModels.value?.componentModels) {
      reactiveComponentModels.value = reactiveComponentModels.value.componentModels;
    }
    return {
      reactiveComponentModels,
    };
  },
  computed: {
    renderingMap() {
      return {
        'page-content': !!this.pageContent,
        'page-heading': !!this.pageHeading,
      };
    },
    uid() {
      const { uid } = this.reactiveComponentModels || {};
      return uid;
    },
    pageHeading() {
      const { heading } = this.reactiveComponentModels || {};
      return heading;
    },
    pageContent() {
      const { sections } = this.reactiveComponentModels || {};
      if (!sections) return null;
      const mapSections = this.mapSections(sections, 1);
      return (!!mapSections.length && mapSections) || null;
    },
  },
  methods: {
    mapSections(sections, index) {
      return sections.map((section) => {
        const level = index + 1;
        return {
          heading: {
            level,
            text: section.heading,
          },
          markup: convertToHtml(section.body),
          subSections: section.subSections ? this.mapSections(section.subSections, level) : null,
        };
      });
    },
  },
};
</script>
<template>
  <div
    class="long-form-page"
    data-ui="long-form-page"
  >
    <section
      v-if="renderingMap['page-content']"
      class="long-form-page__container long-form-page__container--narrow long-form-page__section"
      data-ui="long-form-page-content"
      :data-location-name="analyticsMap['long-form-page-content']"
    >
      <h1
        v-if="renderingMap['page-heading']"
        data-ui="long-form-page-content__heading"
      >
        {{ pageHeading }}
      </h1>
      <longform-component
        v-for="(section, index) in pageContent"
        :key="`subSection-${index + 1}`"
        :section="section"
      />
    </section>
  </div>
</template>

<style lang="scss">
@import "@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss";
@import "@rei/cdr-component-variables/dist/scss/index.scss";

.long-form-page {
  @include cdr-text-body-300;
  padding-top: $cdr-space-one-and-a-half-x;
  padding-bottom: $cdr-space-one-and-a-half-x;

  @include cdr-sm-mq-up {
    padding-top: $cdr-space-three-x;
    padding-bottom: $cdr-space-three-x;
  }

  &__container {
    &--narrow {
      @include cdr-container;
    }
  }

  &__section {
    section:last-child hr {
      display: none;
    }
  }

  h1 {
    @include cdr-text-heading-serif-700;
    margin: 0 0 $cdr-space-four-x;
  }

  h2 {
    @include cdr-text-heading-serif-600;
    margin: 0 0 $cdr-space-one-x;
  }

  h3 {
    @include cdr-text-body-strong-500;
    margin: 0 0 $cdr-space-one-x;
  }
}
</style>
